import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Solid icons
import {
  faPlus as fasPlus,
  faSearch as fasSearch,
  faCheck as fasCheck,
  faUser as fasUser,
  faAngleLeft as fasAngleLeft,
  faAngleRight as fasAngleRight,
  faFolder as fasFolder,
  faFilePdf as fasFilePdf,
  faImage as fasImage,
  faPaperPlane as fasPaperPlane,
  faHome as fasHome,
  faUsers as fasUsers,
  faCloudUploadAlt as fasCloudUploadAlt,
  faTasks as fasTasks,
  faThumbtack as fasThumbtack,
  faBriefcase as fasBriefcase,
  faSignOutAlt as fasSignOutAlt,
  faKey as fasKey,
  faEnvelope as fasEnvelope,
  faTimes as fasTimes,
  faCity as fasCity,
  faStopwatch as fasStopwatch,
  faEllipsisH as fasEllipsisH,
  faFileContract as fasFileContract
} from '@fortawesome/free-solid-svg-icons'

// Regular icons
import {
  faCalendarAlt as farCalendarAlt,
  faClone as farClone,
  faEdit as farEdit,
  faTrashAlt as farTrashAlt,
  faBuilding as farBuilding,
  faStickyNote as farStickyNote,
  faEye as farEye,
  faEyeSlash as farEyeSlash,
  faCopy as farCopy,
  faEnvelope as farEnvelope,
} from '@fortawesome/free-regular-svg-icons'

// Brands icons
import { } from '@fortawesome/free-brands-svg-icons'

library.add(
  fasStopwatch,
  fasCity,
  fasTimes,
  fasEnvelope,
  farEnvelope,
  farEye,
  farEyeSlash,
  farCopy,
  fasPlus,
  farStickyNote,
  fasSearch,
  farCalendarAlt,
  farClone,
  fasImage,
  fasFilePdf,
  farEdit,
  farTrashAlt,
  farBuilding,
  fasCheck,
  fasUser,
  fasAngleLeft,
  fasAngleRight,
  fasFolder,
  fasPaperPlane,
  fasHome,
  fasUsers,
  fasCloudUploadAlt,
  fasTasks,
  fasThumbtack,
  fasBriefcase,
  fasSignOutAlt,
  fasKey,
  fasEllipsisH,
  fasFileContract,
)

Vue.component("font-awesome-icon", FontAwesomeIcon);
